import { defineComponent as _defineComponent } from 'vue'
import VueDraggable from 'vuedraggable';
import { ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import ImageEffectsPropertiesListItem from '@/components/DesignStudio/ImageEffectsProperties/components/list/item/ImageEffectsPropertiesListItem.vue';

interface Emits {
    (event: 'update', effect: ImageEffectType): void;
    (event: 'remove', effect: ImageEffectType): void;
    (event: 'reorder', effects: ImageEffectType[]): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesList',
  props: {
    items: null,
    disabled: { type: Boolean }
  },
  emits: ["update", "remove", "reorder"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update', effect: ImageEffectType): void;
    (event: 'remove', effect: ImageEffectType): void;
    (event: 'reorder', effects: ImageEffectType[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    items: ImageEffectType[];
    disabled?: boolean;
};





const handleUpdate = (imageEffect: ImageEffectType) => {
    emit('update', imageEffect);
};

const handleRemove = (imageEffect: ImageEffectType) => {
    emit('remove', imageEffect);
};

const handleReorder = () => {
    emit('reorder', props.items);
};

return { __sfc: true,props, emit, handleUpdate, handleRemove, handleReorder, VueDraggable, ImageEffectsPropertiesListItem }
}

})